import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { SuppliesDiscountSchema } from "./discount";

export const getSuppliesDiscounts = unaryRpc({
  name: "getSuppliesDiscounts" as const,
  input: z.object({}),
  output: z.object({ discounts: z.array(SuppliesDiscountSchema) }),
});
